/**
 * This response's CSP nonce for the `<style>` elements the app creates at run time (Radix's scroll lock while a
 * dialog is open, through `react-style-singleton`, which asks `get-nonce`). The server writes a fresh nonce into the
 * HTML (`<meta property="csp-nonce" nonce="…">`, Vite's `html.cspNonce`; app-core/vite/csp.ts) and into the
 * policy's style-src-elem; without one (the dev server) styles are allowed inline and nothing is set.
 */
import { setNonce } from "get-nonce";

/** CSP's nonce grammar (base64-value). */
const NONCE = /^[A-Za-z0-9+/_-]+=*$/;

/**
 * `placeholder`: the build's value (`import.meta.env.BREVALT_CSP_NONCE_PLACEHOLDER`, defined by app-core/vite/csp.ts);
 * a page still carrying it was not served with a nonce.
 */
export function applyCspNonce(placeholder: string, doc: Document = document): string | null {
  const meta = doc.querySelector<HTMLMetaElement>('meta[property="csp-nonce"]');
  // Browsers hide the attribute's value once parsed; the property keeps it.
  const nonce = meta?.nonce || meta?.getAttribute("nonce") || "";
  if (!nonce || nonce === placeholder || !NONCE.test(nonce)) return null;
  setNonce(nonce);
  return nonce;
}
